//sass goes here
import "../scss/program.scss";

//
//imported logic goes here
//

//nav bar functionality
import navBarFunc from "./js-comps/navbar";
navBarFunc();

//translation functionality
import translatorFunc from "./js-comps/translator";
translatorFunc();

//gdpr function
import gdprFunctionality from "./js-comps/gdpr";
gdprFunctionality();

//search functionality
import programSearchBarFunctionality from "./js-comps/searchCourse";
programSearchBarFunctionality();

import courseSelectorMobile from "./js-comps/courseSelectorMobile";
courseSelectorMobile();
